<template>
    <div>
        <v-row>
            <v-col cols="12" sm="4">
                <v-text-field
                    v-model="model.order"
                    :label="$t('planPackageModules.form.labels.order')"
                    type="number"
                />
            </v-col>
            <v-col cols="12" sm="4">
                <v-currency-field
                    v-bind="$t('money-config')"
                    v-model="model.price"
                    :label="$t('planPackageModules.form.labels.price')"
                />
            </v-col>
            <v-col cols="12" sm="4">
                <v-radio-group v-model="model.add_on" row>
                    <template #label>
                        <div>
                            <strong>{{
                                $t('planPackageModules.form.labels.add_on')
                            }}</strong>
                        </div>
                    </template>
                    <v-radio :label="$t('form.status.yes')" :value="true" />
                    <v-radio :label="$t('form.status.no')" :value="false" />
                </v-radio-group>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="4">
                <v-radio-group v-model="model.price_type" row>
                    <template #label>
                        <div>
                            <strong>{{
                                $t('planPackageModules.form.labels.price_type')
                            }}</strong>
                        </div>
                    </template>
                    <v-radio :label="'Único'" value="flat" />
                    <v-radio :label="'Por unidade'" value="unit" />
                </v-radio-group>
            </v-col>
            <v-col v-if="showAmount" cols="12" sm="4">
                <v-text-field
                    v-model="model.amount"
                    :label="$t('planPackageModules.form.labels.amount')"
                    type="number"
                />
            </v-col>
            <v-col v-if="showAmount" cols="12" sm="4">
                <v-text-field
                    v-model="model.max_amount"
                    :label="$t('planPackageModules.form.labels.max_amount')"
                    hint="Máximo de unidades selecionáveis considerando a quantidade inicial. Caso deseje ilimitado, deixe -1."
                    persistent-hint
                    type="number"
                />
            </v-col>
        </v-row>

        <v-divider class="my-5"></v-divider>
        <div class="t-heading-medium">Extras</div>
        <v-row>
            <v-col cols="12" sm="4">
                <model-select
                    v-model="dependencySelected"
                    name="dependency"
                    :model="moduleModel"
                    :item-text="'name'"
                    :item-value="'external_id'"
                    :label="$t('planPackageModules.form.labels.dependency')"
                    :multiple="true"
                />
            </v-col>
            <v-col cols="12" sm="4">
                <model-select
                    v-model="courtesySelected"
                    name="courtesy"
                    :model="moduleModel"
                    :item-text="'name'"
                    :item-value="'external_id'"
                    :label="$t('planPackageModules.form.labels.courtesy')"
                    :multiple="true"
                />
            </v-col>
            <v-col cols="12" sm="4">
                <model-select
                    v-model="comboSelected"
                    name="combo"
                    :model="moduleModel"
                    :item-text="'name'"
                    :item-value="'external_id'"
                    :label="$t('planPackageModules.form.labels.combo')"
                    :multiple="true"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import ModelSelect from '@/shared/inputs/ModelSelect'
import Module from '@/models/plans/Module'

export default {
    name: 'PlanPackageModuleFields',
    components: { ModelSelect },
    props: {
        module: {
            type: Object,
            required: true,
        },
        dependencySelection: {
            type: Array,
            default: () => [],
        },
        courtesySelection: {
            type: Array,
            default: () => [],
        },
        comboSelection: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        moduleModel: new Module(),
    }),
    computed: {
        model: {
            get() {
                return this.module
            },
            set(v) {
                this.$emit('input', v)
            },
        },
        dependencySelected: {
            get() {
                return this.dependencySelection
            },
            set(v) {
                this.$emit('update:dependencySelection', v)
            },
        },
        courtesySelected: {
            get() {
                return this.courtesySelection
            },
            set(v) {
                this.$emit('update:courtesySelection', v)
            },
        },
        comboSelected: {
            get() {
                return this.comboSelection
            },
            set(v) {
                this.$emit('update:comboSelection', v)
            },
        },
        showAmount() {
            return (
                this.model &&
                this.model.price_type &&
                this.model.price_type !== 'flat'
            )
        },
    },
}
</script>

<style></style>
